<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">source image</span>
      <a
        href="#"
        @click.prevent="openMediaSourceModal('sourceMedia')"
        class="wf-ml-auto wf-lowercase wf-text-blue-400 wf-underline wf-text-xs wf-cursor-pointer"
      ><i class="fas fa-image wf-mr-1"></i>select image</a>
    </li>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    methods: {
      openMediaSourceModal(conentElement) {
        this.$modal.show('mediaModal', {
          ...this.element,
          mediaElements: this.elementContent.images,
          module: this.module,
          device: this.device,
          element: conentElement,
        })
      },
    },
  })
</script>
